import React, { useEffect } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";

import { getAnalytics } from "../../redux/slices/reportSlice";
import {
  axisProps,
  gridProps,
  compactNumber,
  ChartTooltip,
  ChartLegend,
  ChartEmpty,
  SeriesGradients,
} from "../common/chart";
import theme from "../../theme";

const SERIES = ["Conversions"];

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const Linechart = () => {
  const dispatch = useDispatch();
  const { analytics } = useSelector((state) => state.report);

  useEffect(() => {
    dispatch(getAnalytics());
  }, [dispatch]);

  const data =
    analytics && analytics.camapigns
      ? analytics.camapigns.map((campaign, index) => ({
          name: MONTHS[index],
          Conversions:
            analytics.conversions.conversions[index]?.conversioncount || 0,
        }))
      : [];

  const hasData = data.some((point) => Number(point.Conversions) > 0);

  return (
    <div>
      <div style={{ marginBottom: "16px" }}>
        <ChartLegend keys={SERIES} />
      </div>

      {hasData ? (
        <ResponsiveContainer width="100%" height={320}>
          <AreaChart
            data={data}
            margin={{ top: 8, right: 8, left: -12, bottom: 0 }}
          >
            <SeriesGradients keys={SERIES} idPrefix="rep-month" />
            <CartesianGrid {...gridProps} />
            <XAxis dataKey="name" {...axisProps} />
            <YAxis tickFormatter={compactNumber} {...axisProps} />
            <Tooltip
              cursor={{ stroke: theme.color.border, strokeWidth: 2 }}
              content={<ChartTooltip />}
            />
            <Area
              type="monotone"
              dataKey="Conversions"
              stroke={theme.chart[0]}
              strokeWidth={2}
              fill="url(#rep-month-Conversions)"
              activeDot={{ r: 4, strokeWidth: 2, stroke: "#fff" }}
            />
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <ChartEmpty>No conversions recorded for this period.</ChartEmpty>
      )}
    </div>
  );
};

export default Linechart;
